import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const TrashDeleteIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M6.16667 11.3333V7.33333C6.16667 7.05719 6.39053 6.83333 6.66667 6.83333C6.94281 6.83333 7.16667 7.05719 7.16667 7.33333V11.3333C7.16667 11.6095 6.94281 11.8333 6.66667 11.8333C6.39053 11.8333 6.16667 11.6095 6.16667 11.3333Z"
      fill="currentColor"
    />
    <path
      d="M8.83333 11.3333V7.33333C8.83333 7.05719 9.05719 6.83333 9.33333 6.83333C9.60947 6.83333 9.83333 7.05719 9.83333 7.33333V11.3333C9.83333 11.6095 9.60947 11.8333 9.33333 11.8333C9.05719 11.8333 8.83333 11.6095 8.83333 11.3333Z"
      fill="currentColor"
    />
    <path
      d="M2.83333 13.333V4C2.83333 3.72386 3.05719 3.5 3.33333 3.5C3.60947 3.5 3.83333 3.72386 3.83333 4V13.333C3.83333 13.554 3.92119 13.7666 4.07747 13.9229C4.23366 14.079 4.44552 14.1669 4.66634 14.167H11.3333C11.5542 14.167 11.7659 14.0789 11.9222 13.9229C12.0785 13.7666 12.1663 13.554 12.1663 13.333V4C12.1663 3.72397 12.3903 3.50018 12.6663 3.5C12.9425 3.5 13.1663 3.72386 13.1663 4V13.333C13.1663 13.8192 12.973 14.2861 12.6292 14.6299C12.2854 14.9735 11.8194 15.167 11.3333 15.167H4.66634C4.1803 15.1669 3.71416 14.9735 3.37044 14.6299C3.02662 14.2861 2.83333 13.8192 2.83333 13.333Z"
      fill="currentColor"
    />
    <path
      d="M14 3.5C14.2761 3.5 14.5 3.72386 14.5 4C14.5 4.27614 14.2761 4.5 14 4.5H2C1.72386 4.5 1.5 4.27614 1.5 4C1.5 3.72386 1.72386 3.5 2 3.5H14Z"
      fill="currentColor"
    />
    <path
      d="M10.1663 4.00032V2.66634C10.1662 2.44544 10.0784 2.23367 9.9222 2.07747C9.76593 1.92129 9.55427 1.83333 9.33333 1.83333H6.66634C6.44544 1.83341 6.23367 1.92127 6.07747 2.07747C5.92127 2.23367 5.83341 2.44544 5.83333 2.66634V4.00032C5.83315 4.27631 5.60936 4.50032 5.33333 4.50032C5.05729 4.50032 4.8335 4.27631 4.83333 4.00032V2.66634C4.83341 2.18022 5.0267 1.71418 5.37044 1.37044C5.71418 1.0267 6.18022 0.833414 6.66634 0.833328H9.33333C9.81948 0.833328 10.2854 1.02672 10.6292 1.37044C10.973 1.71418 11.1662 2.18022 11.1663 2.66634V4.00032C11.1662 4.27631 10.9424 4.50032 10.6663 4.50032C10.3905 4.50014 10.1665 4.2762 10.1663 4.00032Z"
      fill="currentColor"
    />
  </svg>
);
